import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './en.json';
import translationPT from './pt.json';
import translationES from './es.json';

// inicia com 'pt' se não houver outro salvo
const savedLanguage = localStorage.getItem('language') || 'pt';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      pt: { translation: translationPT },
      es: { translation: translationES },
    },
    lng: savedLanguage, // Define o idioma inicial como 'pt' se não houver outro salvo
    fallbackLng: 'pt', // fallback também seja português
    interpolation: { escapeValue: false },
  });

export default i18n;
